import moment from 'moment'
import React from 'react'
import { Button } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { store } from 'store/configureStore'
import { defaultToast } from 'utils/toast'

const UserSyncWarningToastContent = ({ closeToast, data }) => {
  const user = store.getState().userReducer.user
  const onButtonClick = () => {
    const errors = data.errors.join('\n')
    const blob = new Blob([errors], { type: 'text/plain' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    const now = new Date()
    const nowFormatted = moment(now).format('YYYY-MM-DD_HH-mm')
    a.download = `erreurs_synchronisation_${user.groupCode}_${nowFormatted}.txt`
    a.click()
    toast.info('Le rapport de synchronisation a été téléchargé, vous pouvez le consulter et le partager en cas de besoin.', defaultToast())
    closeToast(true)
  }

  return (
    <div>
      {data.message}
      {data.syncResult === 'warning' && (
        <Button className="secondary small" onClick={onButtonClick}>
          Voir les problèmes
        </Button>
      )}
    </div>
  )
}

export default UserSyncWarningToastContent
